import apiClient from './apiClient';
import type {
    CreateOptionDto,
    CreateQuestionDto,
    CreateQuestionnaireDto,
    Questionnaire,
    QuestionnaireOption,
    QuestionnaireQuestion,
    QuestionnaireResult,
    UpdateOptionDto,
    UpdateQuestionDto,
    UpdateQuestionnaireDto,
} from '../types/questionnaires';

const questionnairesService = {
    getAll: async (): Promise<Questionnaire[]> => {
        const res = await apiClient.get<Questionnaire[]>('/questionnaires');
        return res.data;
    },

    create: async (dto: CreateQuestionnaireDto): Promise<Questionnaire> => {
        const res = await apiClient.post<Questionnaire>('/questionnaires', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateQuestionnaireDto): Promise<Questionnaire> => {
        const res = await apiClient.put<Questionnaire>(`/questionnaires/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/questionnaires/${id}`);
        return res.data;
    },

    getResults: async (id: number): Promise<QuestionnaireResult[]> => {
        const res = await apiClient.get<QuestionnaireResult[]>(`/questionnaires/${id}/results`);
        return res.data;
    },

    createQuestion: async (questionnaireId: number, dto: CreateQuestionDto): Promise<QuestionnaireQuestion> => {
        const res = await apiClient.post<QuestionnaireQuestion>(`/questionnaires/${questionnaireId}/questions`, dto);
        return res.data;
    },

    updateQuestion: async (id: number, dto: UpdateQuestionDto): Promise<QuestionnaireQuestion> => {
        const res = await apiClient.put<QuestionnaireQuestion>(`/questions/${id}`, dto);
        return res.data;
    },

    removeQuestion: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/questions/${id}`);
        return res.data;
    },

    createOption: async (questionId: number, dto: CreateOptionDto): Promise<QuestionnaireOption> => {
        const res = await apiClient.post<QuestionnaireOption>(`/questions/${questionId}/options`, dto);
        return res.data;
    },

    updateOption: async (id: number, dto: UpdateOptionDto): Promise<QuestionnaireOption> => {
        const res = await apiClient.put<QuestionnaireOption>(`/options/${id}`, dto);
        return res.data;
    },

    removeOption: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/options/${id}`);
        return res.data;
    },
};

export default questionnairesService;
